module.exports = __webpack_public_path__ + "static/media/hero-bg.116fddc0.jpg";